import type { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { careEnvironment } from "@akina/config";
import type { AuthAppState } from "@akina/infra";
import { Auth0Provider } from "@auth0/auth0-react";

//Should be inside the Browser Router to have access to the history
const AuthenticationProvider = ({ children }: { children: JSX.Element }) => {
  const navigate = useNavigate();

  return (
    <Auth0Provider
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      cacheLocation="localstorage"
      onRedirectCallback={appState => {
        const state = appState as AuthAppState;
        if (state?.returnTo) {
          navigate(state.returnTo);
        }
      }}
      domain={careEnvironment.auth0Domain}
      clientId={careEnvironment.auth0ClientId}
      authorizationParams={{
        audience: careEnvironment.auth0Audience,
        redirect_uri: careEnvironment.auth0RedirectUri,
      }}>
      {children}
    </Auth0Provider>
  );
};

export default AuthenticationProvider;
